import PropTypes from 'prop-types';
import React from 'react';
import TableControlBar from 'components/common/table/TableControlBar';

const AdvanceTableControlBar = ({
  actions,
  canNextPage,
  canPreviousPage,
  className,
  filters,
  gotoPage,
  isRefreshing,
  nextPage,
  onRefresh,
  page,
  pageCount,
  pageIndex,
  pageSize,
  previousPage,
  rowCount,
  rowsPerPageOptions,
  search,
  setPageSize
}) => {
  return (
    <TableControlBar
      actions={actions}
      canNextPage={canNextPage}
      canPreviousPage={canPreviousPage}
      className={className}
      filters={filters}
      gotoPage={gotoPage}
      isRefreshing={isRefreshing}
      nextPage={nextPage}
      onRefresh={onRefresh}
      pageCount={pageCount}
      pageIndex={pageIndex}
      pageSize={pageSize}
      previousPage={previousPage}
      rowCount={rowCount}
      rowsPerPageOptions={rowsPerPageOptions}
      search={search}
      setPageSize={setPageSize}
      visibleRowCount={page?.length || 0}
    />
  );
};

AdvanceTableControlBar.propTypes = {
  actions: PropTypes.node,
  canNextPage: PropTypes.bool,
  canPreviousPage: PropTypes.bool,
  className: PropTypes.string,
  filters: PropTypes.node,
  gotoPage: PropTypes.func,
  isRefreshing: PropTypes.bool,
  nextPage: PropTypes.func,
  onRefresh: PropTypes.func,
  page: PropTypes.array,
  pageCount: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  previousPage: PropTypes.func,
  rowCount: PropTypes.number,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  search: PropTypes.node,
  setPageSize: PropTypes.func
};

export default AdvanceTableControlBar;
